import { SegmentedControlProps } from "./types";
import { SegmentButton, SegmentedTrack } from "./styles";

// A filter, not a tablist: nothing it controls is a panel, so pressed buttons in a group.
export const SegmentedControl = <T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  testId,
}: SegmentedControlProps<T>) => {
  return (
    <SegmentedTrack role="group" aria-label={ariaLabel} data-testid={testId}>
      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <SegmentButton
            key={option.value}
            type="button"
            aria-pressed={isActive}
            $active={isActive}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </SegmentButton>
        );
      })}
    </SegmentedTrack>
  );
};
